import { isDefined, type ActivityListInput, type ActivityListSuccess, type WorkflowActivityData } from '@terros/common'
import { useUserCache } from '../user'
import { type InfiniteQueryOptions, useTantalimInfiniteQuery, type GetInfiniteHookResponse } from '../infiniteQuery'
import { activityInfiniteKey } from './keys'

export function useInfiniteActivityList(
  input: ActivityListInput,
  options?: InfiniteQueryOptions
): GetInfiniteHookResponse<WorkflowActivityData> {
  const userCache = useUserCache()
  return useTantalimInfiniteQuery<ActivityListInput, ActivityListSuccess, WorkflowActivityData>({
    url: '/activity/list',
    queryKey: activityInfiniteKey(input),
    input,
    selectRecords: (page) => page.actions,
    onPageFetched: (result) => {
      result.actions.forEach((action) => {
        if (isDefined(action.user)) userCache.setTinyUser(action.user)
      })
    },
    options,
  })
}
